import React, {useEffect} from 'react'
import useUsers from '../../../store/users/usersContext';
import ChevronDown from '../../../components/Icons/solid/ChevronDown';
import { COLORS } from '../../../config';
import Button from '../../../components/Buttons/PrimaryButton'
import useScript from '../../../hooks/useScript';
import useApp from '../../../store/app/appContext'
import DentistCard from '../../../components/Cards/DentistCard';
import useWindowSize from '../../../hooks/useWindowSize';
import PrimaryButton from '../../../components/Buttons/PrimaryButton';


function ChooseDentist({ selectedClinic, pickedDentist, setPickedDentist, handleConfirmDentist, setCurrentStep}) {

  useScript('https://assets.calendly.com/assets/external/widget.js');
	
  const { getClinicDentists } = useUsers();
  
	const [dentists, setDentists] = React.useState([]);
  
  const fetchDentists = () => {
    getClinicDentists(selectedClinic.id).then(res => {
      setDentists(res.data)
    })
  }

	useEffect(() => {
	 if (selectedClinic) return fetchDentists();
   setDentists([]); 
  }, [selectedClinic]) 
  
  const windowSize = useWindowSize();

	return (
    <div className=" h-full flex flex-col justify-between" >
      <ul role="list" className="flex flex-col space-y-4 overflow-y-auto no-scrollbar justify-around px-4 lg:px-40" style={{ height: windowSize.width > windowSize.tailwind.md ? '580px' : '342px' }}>
        {dentists.map(dentist => <DentistCard dentist={dentist} setPickedDentist={setPickedDentist} pickedDentist={pickedDentist}/> )}
      </ul>
      <PrimaryButton text="Confirm dentist" className=""  disabled={!pickedDentist} onClick={() => {handleConfirmDentist()}}/>
      {dentists.length===0 && 
      <div>
        <div className="text-red-500 flex justify-center mt-2">There are no available dentists in this clinic. Please go back to previous step and chose another clinic.</div>
        <PrimaryButton text="Go back" className='md:pt-2 pt-6' onClick={() => {setCurrentStep("2")}}/>
      </div>  
      }
    </div>
  )
}

export default ChooseDentist
